import { call, put, takeEvery } from "redux-saga/effects";
import { tangNhaApi } from "../../../api/category/tangNhaApi";
import { ITangNha } from "../../../model/respone/category/ITangNha";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eTangNhaActionIds,
  ITangNhaActionTypes,
} from "../../action-types/category/ITangNhaActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.tangNha;

export function* tangNhaSaga(): any {
  yield takeEvery(eTangNhaActionIds.LOAD_START, loadWorker);
  yield takeEvery(eTangNhaActionIds.SAVE_START, saveWorker);
  yield takeEvery(eTangNhaActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(tangNhaApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* saveWorker(action: ITangNhaActionTypes): any {
  let res: IBaseRespone = yield call(tangNhaApi.SelectAll);
  const payload = action.payload as ITangNha;
  if (payload.id_tang > 0) {
    res = yield call(tangNhaApi.Update, payload);
  } else {
    res = yield call(tangNhaApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}
function* deleteWorker(action: ITangNhaActionTypes): any {
  const res: IBaseRespone = yield call(
    tangNhaApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
